export const loginMessage = 'Log in to Convey'
export const apiUrl = process.env.REACT_APP_BACKEND_API
export const loginType = 'wallet'
export const PROJECT_NAME = 'convey-admin'
export const REFERRAL_CLIENT_PREFIX = 'cli_'
export const appUrl = process.env.REACT_APP_URL
export const backendUrl = process.env.REACT_APP_BACKEND_API

export const loginOperationId = (type) => {
  let operationId = 'createSessionByEmail'

  if (type === 'wallet') {
    operationId = 'createSessionByWallet'
  }

  if (type === '2fa') {
    operationId = 'createSessionByAttemptToken'
  }

  return operationId
}
